<template>
  <component
    :is="rootElementType"
    class="useful-files-card-link"
    v-bind="elementBindings"
  >
    <div
      class="useful-files-card"
      :style="backgroundImageStyle"
    ></div>

    <div class="text-position">
      <p>
        {{ cardText }}
        <UpArrow v-if="displayArrowIcon" />
      </p>
    </div>
  </component>
</template>

<script lang="ts">
import Vue from 'vue'
import UpArrow from '@/assets/icons/UpArrow.vue'
export default Vue.extend({
  name: 'CardUsefulFiles',
  components: {
    UpArrow
  },
  props: {
    backgroundImageUrl: {
      type: String,
      default: ''
    },
    cardText: {
      type: String,
      default: ''
    },
    navigationUrl: {
      type: String,
      default: null
    },
    displayArrowIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    rootElementType(): string {
      return this.navigationUrl ? 'a' : 'div'
    },
    elementBindings(): Record<string, string> {
      if (!this.navigationUrl) {
        return {}
      }

      return {
        href: this.navigationUrl,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    },
    backgroundImageStyle(): Record<string, string> {
      if (!this.backgroundImageUrl) {
        return {}
      }

      return {
        backgroundImage: `url(${this.backgroundImageUrl})`
      }
    }
  }
})
</script>

<style lang="scss">
.useful-files-card-link {
  text-decoration: none;
  color: inherit;
}

.useful-files-card {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  border-radius: 12px;
  border: 1px solid #ddd;
  background: #4f4f4d;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background-color:gray;

  width: 100%;
  aspect-ratio: 344 / 166;
}

.useful-files-card::after {
  content: '';
  position: absolute;
  inset: 0;
}

.text-position p {
  font-family: InterVariableBold;
  font-size: 16px;
  text-align: left;
}
</style>
